import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import type { DiscoverySettingsObject } from '../../model/DiscoverySettingsObject';
import { toggleFlag } from './toggleFlag';

export const graphCache: FormSnippet<
  DiscoverySettingsObject,
  { graphCache: boolean }
> = {
  render: ({ form }) => (
    <>
      <FormSwitch
        control={form.control}
        name='graphCache'
        label='Loading graph cache'
        description='If disabled, post-discovery computations will be faster, but loading diagrams in the Network Viewer and Path Lookup might take some additional time as computations are done on demand.'
      />
    </>
  ),
  fromModel: (model, fieldValuesDraft) => {
    fieldValuesDraft.graphCache =
      !model.disabledPostDiscoveryActions?.includes('graphCache');
  },
  toModel: (transformedValues, modelDraft) => {
    modelDraft.disabledPostDiscoveryActions ??= [];

    modelDraft.disabledPostDiscoveryActions = toggleFlag(
      modelDraft.disabledPostDiscoveryActions,
      'graphCache',
      transformedValues.graphCache,
    );
  },
  schema: z.object({
    graphCache: z.boolean(),
  }),
};
